var _defs, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSecurityProtocol(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_9852",
    "data-name": "Group 9852",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5643",
    "data-name": "Rectangle 5643",
    width: 492,
    height: 492,
    fill: "none"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5525",
    "data-name": "Rectangle 5525",
    width: 512,
    height: 512,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10052",
    "data-name": "Group 10052",
    transform: "translate(10 10)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10051",
    "data-name": "Group 10051",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6909",
    "data-name": "Path 6909",
    d: "M492,246c0,135.866-110.134,246-246,246S0,381.866,0,246,110.134,0,246,0,492,110.134,492,246",
    fill: "#102c5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_357",
    "data-name": "Subtraction 357",
    d: "M180.8,262.375H24.172A24.2,24.2,0,0,1,0,238.2V24.172A24.2,24.2,0,0,1,24.172,0H180.8a24.213,24.213,0,0,1,24.188,24.172V238.2A24.213,24.213,0,0,1,180.8,262.375Zm-75.641-75.062a6.224,6.224,0,0,0-6.172,5.508v.086l-.031.086a2.175,2.175,0,0,0-.047.453v.359c0,.047.016.086.016.133a1.7,1.7,0,0,1,.016.281,6.264,6.264,0,0,0,6.219,5.625h50.859a6.266,6.266,0,0,0,0-12.531Zm0-66.648a6.209,6.209,0,0,0-6.172,5.477v.07l-.031.07a2.426,2.426,0,0,0-.047.484v.258a1.722,1.722,0,0,0,.031.281v.227a6.264,6.264,0,0,0,6.219,5.625h50.859a6.246,6.246,0,0,0,0-12.492Zm0-66.578a6.2,6.2,0,0,0-6.172,5.508.5.5,0,0,0-.047.172,4.128,4.128,0,0,0-.031.453v.227a1.472,1.472,0,0,0,.016.258l.016.281a6.315,6.315,0,0,0,6.219,5.625h50.859a6.262,6.262,0,0,0,0-12.523Z",
    transform: "translate(143.516 114.816)",
    fill: "#4195c3",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6911",
    "data-name": "Path 6911",
    d: "M25.017,25.717h.008c4.535-.738,8.061,3.633,11.423,7.429a5.324,5.324,0,0,0,7.9.09c4.551-4.9,11.66-12.923,14.752-13.53a4.165,4.165,0,0,1,3.321.353l2.6,2.608a4.846,4.846,0,0,1-.271,4.83,180.642,180.642,0,0,1-22.3,21.935,6.108,6.108,0,0,1-6.191-1.115c-3.756-2.5-22.886-20.689-11.234-22.6",
    transform: "translate(153.365 140.481)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6912",
    "data-name": "Path 6912",
    d: "M62.964,45.729l-.008-.008A156.4,156.4,0,0,1,45.424,63.613,7.026,7.026,0,0,1,35.74,64c-.82-.541-13-12.587-13.4-13.44-1.8-3.8-1.509-7.9,3.034-9.118,3.083-.82,7.495,4.207,11.07,8.11a5.307,5.307,0,0,0,7.757.1c5.092-5.355,12.267-13.866,15.6-13.866a6.484,6.484,0,0,1,5.5,3.936c.836,2.534-1.091,4.182-2.337,6.011",
    transform: "translate(153.451 257.63)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6913",
    "data-name": "Path 6913",
    d: "M42.937,57.053v-.008a8.007,8.007,0,0,1-3.542.435c-4.9-.5-26.617-21.6-14.416-23.6,4.543-.746,8.069,3.633,11.439,7.437a5.327,5.327,0,0,0,7.888.107C48.882,36.537,55.925,28.517,57.992,27.9a5.973,5.973,0,0,1,7.421,4.051,4.342,4.342,0,0,1,.107.443A87.92,87.92,0,0,1,42.937,57.053",
    transform: "translate(153.421 199.131)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurityProtocol);
export default __webpack_public_path__ + "static/media/SecurityProtocol.8e45916ae458b6fc2a9092e6bc2e5718.svg";
export { ForwardRef as ReactComponent };